import { Button, Typography, List, ListItem, Box } from "@mui/material";
import QRCode from "react-qr-code";
import { copyToClipboard, formatValueToBRL } from "../../../utils/common";
import CustomContainer from "../../../components/Container";
import { notifySuccess } from "../../../utils/notify";

export type InvoicePixProps = {
  qrcode: string;
  value: number;
};

function InvoicePix(props: InvoicePixProps) {
  async function copyCode() {
    const copy = await copyToClipboard(props.qrcode);
    if (copy) {
      notifySuccess("Pix copiado com sucesso!");
    }
  }

  const stepCopyList = [
    "Clique no botão e copie o código pix;",
    "Entre no aplicativo do seu banco;",
    "Na área pix escolha “pix copia e cola” para colar o código e finalizar seu pagamento.",
  ];

  const stepQRList = [
    "Entre no aplicativo do seu banco;",
    "Na área pix escolha pagar com “QR code”",
    "Faça a leitura do QR Code e finalize seu pagamento.",
  ];

  const maxWidth = 450;

  return (
    <CustomContainer>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        alignItems="center"
        pb={1}
      >
        <Typography variant="h3" fontWeight="bold" fontSize={24}>
          Valor: {formatValueToBRL(props.value, "R$ ")}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        alignItems={{ xs: "center", md: "start" }}
        justifyContent="center"
        gap={2}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={1}
          width="100%"
          maxWidth={maxWidth}
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            fontSize={24}
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#5e5c5c",
              width: "100%",
              textAlign: "center",
              borderRadius: 1,
              p: 1,
            }}
          >
            QR Code
          </Typography>
          <Box
            sx={{
              p: 1,
              width: 208,
              backgroundColor: "white",
              borderRadius: 1,
            }}
          >
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={props.qrcode}
              viewBox="0 0 256 256"
            />
          </Box>
          <List sx={{ listStyleType: "decimal", pl: 3, pt: 0 }}>
            {stepQRList.map((item, index) => (
              <ListItem
                key={`qr-step-${index}`}
                sx={{
                  display: "list-item",
                  p: 0,
                  pt: 1,
                  fontSize: "0.80rem",
                  fontWeight: 300,
                }}
              >
                {item}
              </ListItem>
            ))}
          </List>
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          width="100%"
          maxWidth={maxWidth}
        >
          <Typography
            variant="h3"
            fontWeight="bold"
            fontSize={24}
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#5e5c5c",
              width: "100%",
              textAlign: "center",
              borderRadius: 1,
              p: 1,
            }}
          >
            Pix Copia e Cola
          </Typography>

          <Button
            variant="contained"
            color="success"
            sx={{
              height: 50,
              width: "100%",
              px: 4,
              maxWidth: { xs: "95%", md: "80%" },
            }}
            onClick={() => copyCode()}
          >
            Copiar código PIX
          </Button>

          <Box
            sx={{
              py: 2,
              px: 1,
              fontSize: "0.62rem",
              letterSpacing: "0.04em",
              fontWeight: 400,
              overflow: "hidden",
              wordBreak: "break-word",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              width: "100%",
              maxWidth: "100%",
              backgroundColor: "#e9e9e9",
              color: "#333",
              borderRadius: 1,
              minHeight: 120,
            }}
          >
            {props.qrcode}
          </Box>

          <List sx={{ listStyleType: "decimal", pl: 3, pt: 0 }}>
            {stepCopyList.map((item, index) => (
              <ListItem
                key={`copy-step-${index}`}
                sx={{
                  display: "list-item",
                  p: 0,
                  pt: 1,
                  fontSize: "0.80rem",
                  fontWeight: 300,
                }}
              >
                {item}
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </CustomContainer>
  );
}

export default InvoicePix;
